<template>
    <div class="home-view">
        <Topbar />
        <div class="container-fluid text-left pl-2 pr-2 d-flex justify-content-center mt-5 pt-4">
            <div class="col-md-6 m-0 p-0">
                <div class="card">
                    <div class="card small">
                        <div class="card-header text-white text-center p-1" :style="{ backgroundColor: moduloAtual().color }">
                            CONSULTA PEDIDOS
                            <div v-show="carregando" class="spinner-grow">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div class="card-body p-1 small text-left">
                            <div class="mt-2 small">

                                <InputDefaultApp
                                    key="pedidoInput"
                                    idInput="pedidoInput"
                                    inputPlaceHolderSufixo="Digite código de barras do pedido"
                                    titleScan="Escanear Pedido"
                                    typeInputMode="text"
                                    @displayScanFunction="buscarPedido"
                                    :enterKey="(e) => buscarPedido(e.target.value)"
                                    :errorMessage="this.pedidoErrorMessage"
                                    :toUpperCase="true"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-5 text-center" v-if="this.pedidosEncontrados && this.pedidosEncontrados.length === 0">
                    <em class="fa fa-frown-open fa-3x mb-2"></em>
                    <br>
                    <span class="small">
                        Nenhum resultado encontrado!
                    </span>
                </div>

                <div class="mb-5" v-if="this.pedidosEncontrados">
                    <div class="card mt-2" v-for="(item) in this.pedidosEncontrados" :key="item.iddocumentos">
                        <div class="card-header p-0 small text-secondary text-center">
                            <span class="font-weight-bold">Nº PEDIDO: </span> 
                            <span class="font-weight-bold text-danger">
                                {{ item.pedido }}
                            </span> 
                        </div>
                        <div class="card-body small text-left text-secondary pt-1 pb-1 pl-2 pr-2">
                            <div class="row small">
                                <div class="col-12">
                                    <span class="font-weight-bold">NOTA FISCAL: </span>
                                    <span class="border bg-warning rounded pl-1 pr-1 text-white" v-if="item.numeronf">
                                        {{ item.numeronf }}
                                    </span>
                                    <span class="border bg-warning rounded pl-1 pr-1 text-white" v-if="!item.numeronf">
                                        NÃO TEM
                                    </span>
                                    <br>
                                    <span class="font-weight-bold">STATUS: </span> 
                                    <span class="border bg-warning text-white rounded pl-1 pr-1">
                                        {{ item.statuslib }}
                                    </span>
                                    <br>
                                    <span class="font-weight-bold">CLIENTE: </span> 
                                    {{ item.fantasia }} - {{ item.idclientes }}
                                    <br>
                                    <span class="font-weight-bold">TRASPORTADORA: </span> 
                                    {{ item.transportadora }}
                                    <br>
                                    <span class="font-weight-bold">VOLUMES: </span> 
                                    {{ parseInt(item.totalvolume) }}
                                    <br>

                                    <div class="border p-2 rounded text-center mt-2">
                                        
                                        <div class="row">
                                            <div class="col-6 text-left small">
                                                <em class="fa fa-check-circle text-success" v-if="item.idpreromaneiossaida"></em>
                                                <em class="fa fa-times-circle text-danger" v-if="!item.idpreromaneiossaida"></em>
                                                <span class="ml-2">PRÉ-EXPEDIÇÃO</span>
                                                <br>
                                                <em class="fa fa-check-circle text-success" v-if="item.idromaneiossaida"></em>
                                                <em class="fa fa-times-circle text-danger" v-if="!item.idromaneiossaida"></em>
                                                <span class="ml-2">EXPEDIÇÃO</span>
                                            </div>
                                            <div class="col-6 text-right">
                                                <router-link class="btn btn-sm btn-info ml-4" :to="{ name: 'consultaPedidoResultado', params: { pedido: item.iddocumentos } }">
                                                    <em class="fa fa-align-justify"></em>
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-5 text-center text-secondary" v-if="!this.pedidosEncontrados">
                    <em class="fa fa-info-circle fa-3x mb-2"></em>
                    <br>
                    <span class="small">
                        <span class="font-weight-bold text-secondary">
                            Opções de busca dos pedidos:
                        </span>
                        <br>
                        <br>
                        1. Nº pedido
                        <br>
                        2. Chave NFe do pedido
                        <br>
                        3. Rastreio do pedido!
                    </span>
                </div>
            </div>
        </div>
        <LogoutModal />
        <FooterBar />
    </div>
</template>
  
  
  <script>
  // @ is an alias to /src
  import Topbar from '@/components/Topbar.vue'
  import FooterBar from '@/components/FooterBar.vue'
  import LogoutModal from '@/components/LogoutModal.vue'
  import InputDefaultApp from '../components/InputDefaultApp.vue';
  import ViewMixin from './ViewMixin'
  import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
  import api, { getUsername, getPerfil } from '../services/api'
  import $ from "jquery"
  import audioService from '@/services/audioService.js';

  export default {
    name: 'ConsultaPedidos',
    mixins: [
      ViewMixin
    ],
    components: {
      Topbar,
      LogoutModal,
      FooterBar,
      InputDefaultApp
    },
  
    data: () => {
      return {
        pedidosEncontrados: null,
        pedidoErrorMessage: null,
      };
    },
  
    async mounted() {
      try {
        await this.validarToken();
        $("#pedidoInput").focus();
      } catch (e) {
        if (e instanceof TokenInvalidoException) {
          this.handleTokenInvalidoException();
        } else if (e instanceof ServerErrorException) {
          alert(e.message);
        } else {
          alert(DEFAULT_ERROR_MESSAGE);
        }      
      }
    },
  
    methods: {
      getUsername,
      getPerfil,

      playSound() {
        audioService.ops();
      },

      async validarToken() {
        this.carregando = true;
  
        await api.get("/validar-token");
  
        this.carregando = false;
      },

      async buscarPedido(codigoBarras) {
                this.carregando = true;
                let body = {
                    "pesquisa": codigoBarras,
                };

                try {
                    let response = await api.post("/pesquisa/pedido", body);

                    if (JSON.stringify(response.data).includes("pedidos"))
                    {   
                        this.pedidosEncontrados = response.data.pedidos;
                        this.pedidoErrorMessage = null;
                        
                        $("#pedidoInput").focus();
                        $("#pedidoInput").select();

                        if (this.pedidosEncontrados.length === 0) {
                            this.pedidoErrorMessage = "Nenhum resultado encontrado!";
                            this.playSound();
                        }
                    }
                } catch (error) {
                    this.pedidoErrorMessage = error.message;
                    this.playSound();
                    $("#pedidoInput").focus();
                    $("#pedidoInput").select();
                }

                this.carregando = false;
            },

            editar(pedido) {
                this.$router.push(`/pedido/editar?p=${btoa(JSON.stringify(pedido))}`);
            },
        }
    }
  </script>
  
  <style scoped lang="scss">    
  
    .home-view {
      height: 100%;
    }
  
    .container-img {
      height: auto;
      display: flex;
      justify-content: center;
      align-self: center;
    }

  </style>
  